/*
 * ===============================================================================================================
 *                                Copyright 2025, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const TITLES = {
  ADD_ENTITLEMENTS: "Add Entitlements",
  APPLICATIONS: "Applications",
  MODULES: "Modules",
  ORGANIZATION: "Organization",
  SELECTED_MODULES: "Selected Modules",
  AVAILABLE_MODULES: "Available Modules",
  EDIT: "Manage Entitlements",
  ADD: "Add",
  DELETE: "Delete",
  CANCEL: "Cancel",
};

export const MESSAGES = {
  NO_ENTITLEMENTS: "No Entitlements",
  UNABLE_TO_DISPLAY_MODULES: "Unable to retrieve modules",
  NO_APPLICATIONS_FOUND: "There are no applications to show",
  DELETE_MODULE_SUCCESS: "Module {0} has been deleted successfully",
  DELETE_MODULE_ERROR: "Error in deleting Module: {0}",
};
